"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var QuotasRowBaseRecord = (0, _immutable.Record)({
  period: null,
  quotaType: null,
  ownerId: null,
  pipelineId: null,
  quotasByStart: (0, _immutable.Map)()
}, 'QuotasRow');

var QuotasRowRecord =
/*#__PURE__*/
function (_QuotasRowBaseRecord) {
  (0, _inherits2.default)(QuotasRowRecord, _QuotasRowBaseRecord);

  function QuotasRowRecord() {
    (0, _classCallCheck2.default)(this, QuotasRowRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QuotasRowRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(QuotasRowRecord, [{
    key: "getKey",
    value: function getKey() {
      return this.ownerId + ":" + this.pipelineId;
    }
  }, {
    key: "setQuota",
    value: function setQuota(quota) {
      return this.set('quotasByStart', this.quotasByStart.set(quota.getStartMs(), quota));
    }
  }, {
    key: "deleteQuota",
    value: function deleteQuota(quota) {
      return this.set('quotasByStart', this.quotasByStart.delete(quota.getStartMs()));
    }
  }, {
    key: "updatePipeline",
    value: function updatePipeline(newPipelineId) {
      return this.set('pipelineId', newPipelineId).set('quotasByStart', this.quotasByStart.map(function (quota) {
        return quota.set('pipelineId', newPipelineId);
      }));
    }
  }]);
  return QuotasRowRecord;
}(QuotasRowBaseRecord);

exports.default = QuotasRowRecord;
module.exports = exports.default;